import moment from 'moment';

import { CONTRACT_TYPES } from '../../../../constants/reports/reports-data';
import Utils from '../../../../utils/immersive_utils';
import { handleOptionsPerAccount } from '../risk-data-per-account';

export const handleOptions = (riskType: string, breakdowns: any[]) => {
  const hasAnyBooks = breakdowns.some((bk: any) => bk.book);

  if (!hasAnyBooks) {
    return handleOptionsPerAccount(riskType, breakdowns);
  }

  const totalAllBooks = breakdowns.find(
    (bk) => bk.contract === CONTRACT_TYPES.OPTION && bk.book === 'ALL' && bk.instrument === 'ALL',
  );

  if (!totalAllBooks) {
    return null;
  }

  const uniqueBooks = Array.from(
    new Set(
      breakdowns
        .filter((bk) => bk.contract.includes(CONTRACT_TYPES.OPTION) && bk.book !== 'ALL')
        .map((bk) => bk.book),
    ),
  );

  const bookChildren = uniqueBooks.map((bookName) => {
    const totalBook = breakdowns.find(
      (bk) =>
        bk.contract.includes(CONTRACT_TYPES.OPTION) &&
        bk.book === bookName &&
        bk.instrument === 'ALL',
    );
    const bookValues = totalBook ? totalBook.risk : [];

    const breakdownsForBook = breakdowns.filter(
      (bk) => bk.contract.includes(CONTRACT_TYPES.OPTION) && bk.book === bookName,
    );

    const expiries = groupByExpiry(riskType, breakdownsForBook);

    return {
      id: `${riskType}-options-book-${bookName}`,
      label: bookName,
      values: bookValues,
      children: expiries,
    };
  });

  return {
    id: `${riskType}-options`,
    label: 'Options',
    values: totalAllBooks.risk,
    children: bookChildren,
  };
};

function groupByExpiry(riskType: string, breakdownsForBook: any[]) {
  const dateAggregators = breakdownsForBook.filter(
    (bk) => bk.instrument === 'ALL' && bk.contract.startsWith(`${CONTRACT_TYPES.OPTIONS}-`),
  );

  if (!dateAggregators.length) {
    return [];
  }

  return dateAggregators.map((aggregator) => {
    const datePart = aggregator.contract.split('-')[1];
    const dateLabel = moment(Utils.parseDate(datePart)).format('YYYY-MM-DD');

    const instrumentsForDate = breakdownsForBook.filter((bk) => {
      if (bk.contract !== CONTRACT_TYPES.OPTION) return false;
      const parts = bk.instrument.split('-');
      const normalizedPart = parts[1]?.replace(/^(\d)([A-Z]{3}\d{2})$/, '0$1$2');
      return normalizedPart === datePart;
    });

    const children = instrumentsForDate.map((optionBk) => ({
      id: `${riskType}-option-${optionBk.instrument}`,
      label: optionBk.instrument,
      values: optionBk.risk,
      position: optionBk.position,
    }));

    return {
      id: `${riskType}-options-date-${datePart}`,
      label: dateLabel,
      values: aggregator.risk,
      position: 'Position',
      children,
    };
  });
}
